var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.974 2.447a.75.75 0 0 0-1.272-.709l-10.5 11.25a.75.75 0 0 0 .548 1.262h7.268l-1.992 7.303a.75.75 0 0 0 1.272.709l10.5-11.25a.75.75 0 0 0-.548-1.262h-7.268zm-2.378 10.598A.75.75 0 0 0 12 12.75H5.476l7.252-7.77-1.452 5.323a.75.75 0 0 0 .724.947h6.524l-7.252 7.77 1.452-5.323a.75.75 0 0 0-.128-.652",
    clipRule: "evenodd"
  })));
};
export default SvgBolt;